import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import crmServices from '../../wsclient/crmservices'
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert'
import Loading from '../../components/Loading'
import { getAppCfg, getBrowser, getCountryDefault } from '../../utils/common';
import RegisterVerificationView from '../register/RegisterVerificationView';
import CredentialsController from '../identify/CredentialsController';
import RegisterExistingView from './RegisterExistingView';
import { paths } from '../../../portal.router.config';
import crmservices from '../../wsclient/crmservices';
import RegisterExistingOTPView from './RegisterExistingOTPView';
import { airlinkservices } from '../../wsclient/crmservices/airlinkservices';

const styles = theme => ({

});

function RegisterExistingController(props) {
    const config = getAppCfg()
    let agreement_countries = config && config.contact && config.contact.agreement_countries ? config.contact.agreement_countries : null
    let country_default = getCountryDefault(agreement_countries);

    const [active, setActive] = useState('main');
    const [method_select, onSelectMethod] = useState('PHONE');
    const [verify_type, onSelectVerify] = useState('EMAIL');
    const [showLoading, onShowLoading] = useState(false);
    const [error, setError] = useState({});
    const [auth_otp, setAuthOtp] = useState(null);
    const [obfuscated_value, setObfuscatedValue] = useState('');
    const [contact, setContact] = useState(null);
    const [register_info, setRegisterInfo] = useState({});
    const [auth_support, setAuthSupport] = useState('EMAIL');
    const [customer, setCustomer] = useState(null);
    const [showFormCredential, setShowFormCredential] = useState(false);
    const [isAcceptTerm, setIsAcceptTerm] = useState(false);
    const appConfig = getAppCfg();
    const authSupportOTP = appConfig && appConfig.auth_support.email_otp ? appConfig.auth_support.email_otp : null;

    const onRequestOTP = async (email) => {
        try {
            var result = await crmservices.contacts.sendCredentialsOTP({
                send_method: 'EMAIL',
                name: auth_support,
                value: email,
            });
            console.log("result onRequestOTP==", result);
            if (result.code == 'OK') {
                setActive('verify');
            } else {
                console.log("error onRequestOTP:", result.code);
                showAlert('ERROR', t(result.code))
            }
        } catch (error) {
            console.log("register onRequestOTP exception:", error);
            showAlert('ERROR', t('EXCEPTION_PROCESS'));
        }
    }

    const onVerifyOTP = async (code) => {
        console.log("customer===", customer);
        onShowLoading(true);
        try {
            let result = await crmServices.contacts.validateEmailOTP({
                email: customer && customer.email_address ? customer.email_address : null,
                auth_otp: auth_support,
                otp: code.verification_code
            });
            console.log("result validateEmailOTP:", result);
            if (result.code == 'OK') {
                setContact(result.data);
                setShowFormCredential(true);
                setActive('main');
                //await onCredentials();
            } else if(result.code === 'INVALID_LOGIN'){
                showAlert('ERROR', t('INVALID_OTP'))
            }
            else {
                console.log("error validateEmailOTP:", result.code);
                showAlert('ERROR', t(result.code))
            }
        } catch (error) {
            console.log("error onVerifyOTP:", error);
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }

    const onCredentials = async (values) => {
        try {
            onShowLoading(true)
            const { email, password} = values;
            console.log("values register info==", values);
            let jwtDecode = require('jwt-decode');
            let contact_id = null;
            const access_token = contact && contact.access_token ? contact.access_token : null
            if (access_token) {
                contact_id = jwtDecode(access_token).sub
                console.log('jwtDecode(access_token)===', jwtDecode(access_token))
            }
            if (!contact_id) {
                showAlert('ERROR', t('Can not access token'))
                return;
            }
            let result = await crmServices.contacts.credentialsByEmail(email, password ? password : null, contact_id, access_token);
            onShowLoading(false)
            console.log("credentialsByEmail OTP===", result);
            // debugger;
            if (result.code == 'OK') {
                showAlert('SUCCESS', authSupportOTP ? t('REGISTER_EMAIL_SMS') : t('REGISTER_EMAIL_SUCCESS'), null, onAuthCredentials);
                // onAuthCredentials();
            } else if (result.code === 'INVALID_CONTACTPASSWORD_EXCEPTION') {
                showAlert('ERROR', t('INVALID_CONTACTPASSWORD_EXCEPTION'));
            } else {
                console.log("error sendCredentialsOTP:", result.code);
                showAlert('ERROR', t(result.code))
            }
        } catch (error) {
            console.log('onCredentials error:', error)
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
    }

    const onResendCode = async () => {
        onShowLoading(true);
        try {
            let result = await crmServices.contacts.sendCredentialsOTP({ 
                send_method: 'EMAIL',
                name: auth_support,
                value: customer && customer.email_address ? customer.email_address : null, 
            });
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp)
                }
                if (verify_type === 'email')
                    showAlert('ERROR', t('OTP_RESEND_EMAIL_SUCCESS'));
                else
                    showAlert('ERROR', t('OTP_RESEND_SUCCESS'));

            } else {
                console.log("error onResendCode:", result.code);
                showAlert('ERROR', t(result.code))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }

    const onGetCustomers = async (values) => {
        console.log("values====", values);
        onShowLoading(true);
        try {
            let domain = document._portalConfig.domainCustomer;
            if(!domain) domain = 'airlink';
            let result = await airlinkservices.getCustomers(values.email, domain);
            console.log("getCustomers result===",  result);
            if (result.code == 'OK') {
                if (result.data && result.data.customers && result.data.customers.content && result.data.customers.content.length > 0) {
                    let customer = result.data.customers.content[0];
                    setCustomer(customer);
                    if (customer.email_address) {
                        if(result.data.is_verified) showAlert('ERROR', t('REGISTRATION_FAIL_CONTACT_EXISTS'));
                        //call request otp
                        else await onRequestOTP(customer.email_address);
                    }
                    else showAlert('ERROR', t('can_not_find_email_customer'));
                }else showAlert('ERROR', t('can_not_find_customer'));
            } else {
                console.log("error onGetCustomers:", result.code);
                showAlert('ERROR', t(result.code))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }

    const showAlert = async (status, message, title, closeCustom) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
            onClose: closeCustom
        });
    }

    const onCloseAlert = async () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
            onClose: null
        });
    }

    const onAuthCredentials = () => {
        props.history.push(paths.login);
    }

    const renderView = () => {
        if(authSupportOTP){
            return (
                <RegisterExistingOTPView
                    onSubmit={showFormCredential ? onCredentials : onGetCustomers}
                    showAlert={showAlert}
                    onShowLoading={onShowLoading}
                    onSelectVerify={onSelectVerify}
                    onSelectMethod={onSelectMethod}
                    agreement_countries={agreement_countries}
                    showFormCredential={showFormCredential}
                    customer={customer}
                />
            );
        }else{
            return (
                <RegisterExistingView
                    onSubmit={showFormCredential ? onCredentials : onGetCustomers}
                    showAlert={showAlert}
                    onShowLoading={onShowLoading}
                    onSelectVerify={onSelectVerify}
                    onSelectMethod={onSelectMethod}
                    agreement_countries={agreement_countries}
                    showFormCredential={showFormCredential}
                    customer={customer}
                    isAcceptTerm={isAcceptTerm}
                    setIsAcceptTerm={setIsAcceptTerm}
                />
            );
        }
    }

    return (
        <div>
            {active === 'main' && renderView()}
            {active === 'verify' && <RegisterVerificationView
                onSubmit={onVerifyOTP}
                onResend={onResendCode}
                obfuscated_value={obfuscated_value}
                email={verify_type === 'EMAIL'} />}
            <ModalAlert
                open={error.showAlert}
                onClose={error.onClose ? error.onClose : onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
            {showLoading && <Loading showLoading={showLoading} />}
        </div>

    );
}

export default withStyles(styles)(withTranslation()(RegisterExistingController));